.ugc-review-mw-all-images-detail-modal-wrap {
  display: flex;
  gap: 6px;
  overflow: hidden;
  .image-item.left {
    display: flex;
    flex-direction: row-reverse;
    width: 16px;
  }
  .image-item.center {
    flex: 1 1 0%;
    > img {
      width: 100%;
    }
  }
  .image-item.right {
    flex: none;
    width: 16px;
  }
}
.ugc-customer-images-detail-content-wrap {
  position: relative;
  .ugc-customer-images-detail-content-mantle {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    opacity: 0;
    background: #fff;
    transition: all linear 0.2s;
    &.active {
      opacity: 1;
      z-index: 999;
    }
  }
}